export const defaultConfig = {
  // If the image gets within 50px in the Y axis, start the download.
  rootMargin: '50px 0px',
  threshold: 0.01,
};

export const LAZY_IMAGE_SELECTOR = '.lazy';
export const LAZY_IMAGE_LOADED_CLASS = 'loaded';
